import { IonContent, IonPage, useIonToast } from '@ionic/react'
import { checkbox, warning } from 'ionicons/icons'
import { useContext, useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router'
import styled from 'styled-components'
import { VALIDATE_STATUS } from '../../../common'
import { CustomSpacer, TextStyle, StyleIonHeader, FooterButtons } from '../../../components'
import { DivideLineBold } from '../../../components/atoms/divide'
import { StyleIonInput } from '../../../components/atoms/input/StyleIonInput'
import { StoresContext } from '../../../provider/StoreProvider'

export const SettingCashReceipt: React.FC<RouteComponentProps> = ({ history }) => {
  const { myStore } = useContext(StoresContext)
  const [phoneNum, setPhoneNum] = useState<string | undefined>()
  const [validateStatus, setValidateStatus] = useState<VALIDATE_STATUS>(VALIDATE_STATUS.INPUT)
  const [presentToast] = useIonToast()

  const onInputName = (bankOwner: string | number) => {
    setPhoneNum(String(bankOwner))
  }

  const validate = () => {
    if (phoneNum != undefined && phoneNum?.length > 0) {
      setValidateStatus(VALIDATE_STATUS.OKAY)
    } else {
      setValidateStatus(VALIDATE_STATUS.INPUT)
    }
  }

  const onModifyUserInfo = async () => {
    const modifyResult = await myStore.modifyUserInfo({
      extraData: {
        receiptPhoneNumber: phoneNum as string,
      },
    })
    if (modifyResult) {
      await presentToast({
        message: '정보 수정이 정상적으로 완료되었습니다.',
        duration: 3000,
        position: 'top',
        color: 'primary',
        icon: checkbox,
      })
      await history.push('/myPage/setting')
    } else {
      await presentToast({
        message: '정보 수정에 실패했습니다. 잠시 후 다시 시도해주세요!',
        duration: 3000,
        position: 'top',
        color: 'danger',
        icon: warning,
      })
    }
  }

  useEffect(() => {
    validate()
  }, [phoneNum])

  return (
    <IonPage>
      <StyleIonHeader type={'SUB'} title={'현금영수증'} href={'/myPage/setting'} />
      <IonContent>
        <SectionContainer>
          <TextStyle type={'r_13'}>휴대폰번호</TextStyle>
          <CustomSpacer spacing="8px" />
          <StyleIonInput
            type={'text'}
            inputmode={'text'}
            inputType={'INPUT'}
            placeholder={'000-0000-0000'}
            onInput={onInputName}
          />
        </SectionContainer>
        <DivideLineBold />
        <InfoContainer>
          <TextStyle type={'sb_13'}>유의사항</TextStyle>
          <ul>
            <li>현금영수증 발행은 개인 휴대폰 번호에 한하여 가능합니다.</li>
            <li>법인 사업자등록번호 등록은 불가합니다.</li>
          </ul>
        </InfoContainer>
      </IonContent>
      <FooterButtons
        button={{
          color: 'dark',
          text: validateStatus !== VALIDATE_STATUS.OKAY ? '내용을 입력해주세요.' : '변경하기',
          disabled: validateStatus !== VALIDATE_STATUS.OKAY ? true : false,
          onClick: () => onModifyUserInfo(),
        }}
      />
    </IonPage>
  )
}

const SectionContainer = styled.div`
  padding: 24px 20px;
`

const InfoContainer = styled.div`
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  font-size: 1px;
  ul {
    padding-left: 20px;
    font-size: 13px;
    color: var(--ion-color-primary_light);
    line-height: 21px;
    margin: 5px 0;
  }
`
